import { FormattedMessage } from 'react-intl';
import { Flex, Text } from '@chakra-ui/react';

const EmptyGraph = ({ messageId }) => {
    return (
        <Flex h="300px" justify="center" align="top">
            <Text size="sm" variant="regular">
                <FormattedMessage id={messageId} />
            </Text>
        </Flex>
    );
};

export default EmptyGraph;
